import { isEqual } from 'lodash';

export function isObjectsEqual<T>(obj1: T, obj2: T): boolean {
    const normalizeStrings = (v: any): any =>
        typeof v === 'string' ? v.replace(/\s+/g, '') : v;

    const deepNormalize = (obj: any): any => {
        if (Array.isArray(obj)) return obj.map(deepNormalize);
        if (obj && typeof obj === 'object') {
            return Object.fromEntries(
                Object.entries(obj).map(([k, v]) => [k, deepNormalize(v)])
            );
        }
        return normalizeStrings(obj) || null;
    };

    return isEqual(
        deepNormalize(obj1),
        deepNormalize(obj2)
    );
}